import { surrenderBenefit } from "../../engine/calculations";

const config = {
  key: "insurance-surrender",
  title: "Insurance Surrender Cost-Benefit",
  category: "Insurance & Protection",
  description: "Compare surrendering a policy and investing the proceeds against continuing to maturity.",
  fields: [
    { key: "surrenderValue", label: "Current surrender value", type: "currency", default: 2_00_000, min: 0, max: 10_00_00_000 },
    { key: "remainingAnnualPremium", label: "Remaining annual premium", type: "currency", default: 40_000, min: 0, max: 50_00_000, help: "What you'd save each year by not continuing the policy." },
    { key: "yearsLeft", label: "Years left on the policy", type: "number", default: 8, min: 1, max: 40 },
    { key: "maturityValue", label: "Maturity value if you continue", type: "currency", default: 8_00_000, min: 0, max: 10_00_00_000 },
    { key: "altRate", label: "Alternative investment return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const surrenderValue = Number(values.surrenderValue) || 0;
    const remainingAnnualPremium = Number(values.remainingAnnualPremium) || 0;
    const yearsLeft = Number(values.yearsLeft) || 0;
    const maturityValue = Number(values.maturityValue) || 0;
    const altRate = (Number(values.altRate) || 0) / 100;

    const result = surrenderBenefit(surrenderValue, remainingAnnualPremium, yearsLeft, maturityValue, altRate);
    const betterOption = result.benefit > 0 ? "Surrender & invest" : "Continue the policy";

    return {
      headline: { label: "Better option", value: betterOption, format: "text" },
      extraHeadlines: [{ label: "Difference in your favour", value: Math.abs(result.benefit) }],
      breakdown: [
        { label: "Surrender & invest ends with", value: result.surrenderAndInvest },
        { label: "Continuing ends with", value: result.continuePolicy },
      ],
      series: [
        { name: "Surrender & invest", amount: result.surrenderAndInvest },
        { name: "Continue policy", amount: result.continuePolicy },
      ],
    };
  },
};

export default config;
